import { render } from "./SchedulePage.vue?vue&type=template&id=a8fe84f0&scoped=true"
import script from "./SchedulePage.vue?vue&type=script&lang=js"
export * from "./SchedulePage.vue?vue&type=script&lang=js"

import "./SchedulePage.vue?vue&type=style&index=0&id=a8fe84f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8fe84f0"]])

export default __exports__